module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "relation"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100vw"
    },
    attrs: {
      "justify": "space-around",
      "align": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": {
        span: 22,
        pull: 1,
        push: 1
      },
      "lg": {
        span: 22,
        pull: 1,
        push: 1
      },
      "xl": {
        span: 22,
        pull: 1,
        push: 1
      }
    }
  }, [_c('el-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    },
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": {
        span: 2,
        offset: 3
      },
      "lg": {
        span: 2,
        offset: 3
      },
      "xl": {
        span: 2,
        offset: 3
      }
    }
  }, [_c('MyIcon', {
    attrs: {
      "img": _vm.imgs[0]
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    },
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 2,
      "lg": 2,
      "xl": 2
    }
  }, [_c('MyIcon', {
    attrs: {
      "img": _vm.imgs[1]
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    },
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 2,
      "lg": 2,
      "xl": 2
    }
  }, [_c('MyIcon', {
    attrs: {
      "img": _vm.imgs[2]
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    },
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 2,
      "lg": 2,
      "xl": 2
    }
  }, [_c('MyIcon', {
    attrs: {
      "img": _vm.imgs[3]
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    },
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 2,
      "lg": 2,
      "xl": 2
    }
  }, [_c('MyIcon', {
    attrs: {
      "img": _vm.imgs[4]
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    },
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 2,
      "lg": 2,
      "xl": 2
    }
  }, [_c('MyIcon', {
    attrs: {
      "img": _vm.imgs[5]
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    },
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 2,
      "lg": 2,
      "xl": 2
    }
  }, [_c('MyIcon', {
    attrs: {
      "img": _vm.imgs[6]
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    },
    attrs: {
      "xs": 6,
      "sm": 6,
      "md": 2,
      "lg": 2,
      "xl": 2
    }
  }, [_c('MyIcon', {
    attrs: {
      "img": _vm.imgs[7]
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "content-c1",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5,
      "xl": 5
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.hwadzanUrl
    }
  }, [_vm._v("華藏淨宗弘化網")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-c2",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5,
      "xl": 5
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.amtbcollege.com/"
    }
  }, [_vm._v("佛陀教育網路學院")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-c1",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5,
      "xl": 5
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://rsd.amtb.tw/"
    }
  }, [_vm._v("儒釋道文化教育網")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-c1",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4,
      "xl": 4
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://new.jingzong.org/"
    }
  }, [_vm._v("澳洲淨宗學院")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-c1",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5,
      "xl": 5
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.amtbcollege.org/order"
    }
  }, [_vm._v("訂閱佛陀教育雜誌")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "cop",
    staticStyle: {
      "width": "80vw"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-col', {
    staticClass: "content-c31",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5,
      "xl": 5
    }
  }, [_c('span', {
    staticClass: "content-c3"
  }, [_vm._v("淨空老法師專集網")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-c0",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5,
      "xl": 5
    }
  }, [_c('span', {
    staticClass: "content-c3",
    on: {
      "click": _vm.openmail
    }
  }, [_vm._v("email:amtb@amtb.tw")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-c31",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5,
      "xl": 5
    }
  }, [_c('span', {
    staticClass: "content-c3"
  }, [_vm._v("建站日:1995.12.1")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-c31",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5,
      "xl": 5
    }
  }, [_c('span', {
    staticClass: "content-c3"
  }, [_vm._v("備案序號:"), _c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("蘇ICP備06004660號")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-c31",
    attrs: {
      "push": -1,
      "xs": 24,
      "sm": 24,
      "md": 3,
      "lg": 3,
      "xl": 3
    }
  }, [_c('span', {
    staticClass: "content-c3"
  }, [_c('a', {
    attrs: {
      "href": "/blog/privacy",
      "target": "_blank"
    }
  }, [_vm._v("Privacy隱私權政策")])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0099421c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/footer.vue
// module id = 1043
// module chunks = 3